import "@hotwired/turbo-rails"
import "./controllers";
import $ from "jquery";
window.$ = window.jQuery = $;
